import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CoachMark from '@shopDetails/components/CoachMark/CoachMark';
import Logo from '@assets/images/pickup/pickup.png';
import { injectIntl } from 'react-intl';
import OnlinePaymentOnly from '../OnlinePaymentOnly';
import messages from './messages';

const Image = styled.img`
  margin-right: ${({ theme }) => theme.spacing(8)};
  height: ${({ theme }) => theme.spacing(53)};
  margin-bottom: ${({ theme }) => theme.spacing(4)};
`;
const Title = styled.div`
  ${({ theme }) => theme.fontFamily.mainFont.xSmallExtraBold}
  align-self: center;
  width: 100%;
  margin-right: ${({ theme }) => theme.spacing(16)};
`;

const Description = styled.div`
  ${({ theme }) => theme.fontFamily.secondaryFont.xSmallRegular}
  align-self: center;
  line-height: 20px;
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing(3)};
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: -26px;
`;

const PickupCoachMark = ({
  isOpen = false,
  onClose,
  intl: { formatMessage },
}) => (
  <CoachMark open={isOpen} onClose={onClose}>
    <Container>
      <Image src={Logo} />
      <Title>
        {formatMessage(messages.coachMarkTitle)}
        <Description>
          {formatMessage(messages.coachMarkDescription)}
        </Description>
        <OnlinePaymentOnly />
      </Title>
    </Container>
  </CoachMark>
);

PickupCoachMark.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  intl: PropTypes.object,
};

export default injectIntl(PickupCoachMark);
